<template>
    <div
        :class="classname"
        class="notification"
        title="Klik om te verbergen"
        @click="hide(notification)"
    >
        <div class="notification-icon">
            <i
                class="fas fa-3x"
                :class="notification.icon"
            ></i>
        </div>
        <div class="notification-container border bg-body">
            <div class="notification-header">
                {{ notification.title }}
            </div>
            <div class="notification-content">
                {{ notification.message }}
            </div>
        </div>
    </div>
</template>

<style>
.fade-out {
    opacity: 0;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.notification {
    display: flex;
    margin: 1rem;
    margin-top: 0;
    border-radius: 10px;
    max-width: calc(100vw - 2rem);
}

.notification-icon {
    background-color: #ee7200;
    color: white;
    width: 80px;
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 0px 0px 10px;
    flex-grow: 0;
    flex-shrink: 0;
}

.notification-header {
    font-weight: 600;
}

.notification-container {
    border-radius: 0px 10px 10px 0px;
    padding: 1rem;
    width: 30rem;
}
</style>

<script>
export default {
    name: "Notification",
    props: {
        notification: {
            type: Object,
        },
    },
    data() {
        return {
            classname: "",
        };
    },
    mounted() {
        if (!this.notification.disableAutoHide) {
            this.autoHide();
        }
    },
    methods: {
        autoHide() {
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                    // 30 seconds
                }, 30000);
            }).then(() => {
                this.hide();
            });
        },
        hide() {
            this.classname = "fade-out";
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                    // 0.5 seconds -- to match transition
                }, 500);
            }).then(() => {
                this.$parent.hide(this.notification);
            });
        },
    },
};
</script>
